import React, { Component, Suspense } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route } from 'react-router';
import Progress from './Progress';

const mapStateToProps = ({ auth }) => ({
    isAuthenticated: auth.authenticated,
});
const loginRoute = '/login';
const mapDispatch = (dispatch) => ({
    setTitle: (title, description) => dispatch.app.setTitle({ title, description }),
});

const reduxConnector = connect(mapStateToProps, mapDispatch);

class Router extends Component {
    state = {};

    componentDidMount() {
        const { setTitle, title, description } = this.props;

        setTitle(title, description);
    }

    componentDidUpdate(prevProps) {
        const {
            setTitle, title, description,
        } = this.props;
        if (title !== prevProps.title) {
            setTitle(title, description);
        }

        return null;
    }

    render() {
        const { component: Component, isAuthenticated, ...rest } = this.props;

        let { requireAuth } = rest;

        if (!requireAuth) {
            requireAuth = false;
        }

        // If user authenticated
        if (isAuthenticated) {
            return (
                <Suspense fallback={<Progress />}>
                    <Route {...rest} render={(props) => <Component {...props} />} />
                </Suspense>
            );
        }

        // page doesn't require Auth
        if (requireAuth === false) {
            return (
                <Suspense fallback={<Progress />}>
                    <Route {...rest} render={(props) => <Component {...props} />} />
                </Suspense>
            );
        }

        // If page require Auth redirect user to login routes
        return (
            <Suspense fallback={<Progress />}>
                <Route
                    {...rest}
                    render={(props) => (
                        <Redirect
                            to={{
                                pathname: `${loginRoute}`,
                                state: { from: props.location },
                            }}
                        />
                    )}
                />
            </Suspense>
        );
    }
}

Router.propTypes = {};
Router.defaultProps = {};

export default reduxConnector(Router);
